var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid"},[_c('admin-items',{staticClass:"admin-items"}),_c('div',{staticClass:"admin-users"},[_c('admin-users')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }